import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const SexoList = props => <DefaultDataTable data={props} />;
